export default "__VITE_ASSET__OqGbCTML__"